import Progress from './progress';
export default Progress;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/progress/index.js
// module id = 332
// module chunks = 0